import React from 'react';
import { TalentMatchingFilters } from 'talent_matching/types';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import AppReviewTableWrapper from 'talent_matching/components/table/app_review_table_wrapper';
import { FORM_DEFAULTS } from 'talent_matching/filter_form_defaults';

const FilterForm = ({
  initialFilters,
}: {
  initialFilters: Partial<TalentMatchingFilters>;
}) => {
  const onSubmit = () => {
    // Form is only used to control overall state and apply saved filter states
  };

  return (
    <Form<TalentMatchingFilters>
      defaultValues={{ ...FORM_DEFAULTS, ...initialFilters }}
      onSubmit={onSubmit}
    >
      <AppReviewTableWrapper />
    </Form>
  );
};

export default FilterForm;
